import { useEffect, useSyncExternalStore } from 'react';
import { useSession } from '../lib/session';
import {
  applyTheme, readPreference, resolveTheme, subscribePreference, type Theme, type ThemePreference, writePreference,
} from '../lib/theme';
import { useMediaQuery } from './useMediaQuery';
import { useNow } from './useNow';

/** Tema en uso y la preferencia de la persona. La zona horaria es la del perfil si hay sesión. */
export function useTheme(): { preference: ThemePreference; theme: Theme; timeZone: string | undefined; setPreference: (p: ThemePreference) => void } {
  const preference = useSyncExternalStore(subscribePreference, readPreference);
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)');
  const session = useSession();
  const timeZone = session.data?.user.timezone;
  const now = useNow(60_000);
  const theme = resolveTheme(preference, systemDark, new Date(now), timeZone);
  return { preference, theme, timeZone, setPreference: writePreference };
}

/** Aplica el tema al documento. Montado una vez en la raíz. */
export function ThemeController() {
  const { theme } = useTheme();
  useEffect(() => applyTheme(theme), [theme]);
  return null;
}
